import { render, staticRenderFns } from "./sky-uploadimg-select.vue?vue&type=template&id=60f1e812&scoped=true"
import script from "./sky-uploadimg-select.vue?vue&type=script&lang=js"
export * from "./sky-uploadimg-select.vue?vue&type=script&lang=js"
import style0 from "./sky-uploadimg-select.vue?vue&type=style&index=0&id=60f1e812&prod&lang=scss&scoped=true"
import style1 from "./sky-uploadimg-select.vue?vue&type=style&index=1&id=60f1e812&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1e812",
  null
  
)

export default component.exports